import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { InlineClassDescriptor2odlvyasjrmr0 as InlineClassDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/InlineClassDescriptor.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { FloatSerializer_getInstance1c6yoefuaocts as FloatSerializer_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _Angle___init__impl__g23q1m(turns) {
  return turns;
}
function _Angle___get_turns__impl__atdtw5($this) {
  return $this;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.RADIANS_PER_CIRCLE_1 = 6.2831855;
        this.DEGREES_PER_CIRCLE_1 = 360.0;
        this.zero_1 = _Angle___init__impl__g23q1m(0.0);
        this.circle_1 = _Angle___init__impl__g23q1m(1.0);
        this.halfTurn_1 = _Angle___init__impl__g23q1m(0.5);
        this.quarterTurn_1 = _Angle___init__impl__g23q1m(0.25);
        this.eighthTurn_1 = _Angle___init__impl__g23q1m(0.125);
        this.thirdTurn_1 = _Angle___init__impl__g23q1m(1 / 3.0);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('com.lightningkite.kiteui.models.Angle', this);
        tmp0_serialDesc.addElement_5pzumi_k$('turns', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_sso3wx_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeFloat_b8b85a_k$(_Angle___get_turns__impl__atdtw5(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_sso3wx_k$(encoder, value instanceof Angle() ? value.turns_1 : THROW_CCE());
      }
      deserialize_2kb93c_k$(decoder) {
        return _Angle___init__impl__g23q1m(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeFloat_jcnrwu_k$());
      }
      deserialize_sy6x50_k$(decoder) {
        return new (Angle())(this.deserialize_2kb93c_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [FloatSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
function Angle__toString_impl_786qky($this) {
  return 'Angle(turns=' + $this + ')';
}
function Angle__hashCode_impl_szcndt($this) {
  return getNumberHashCode($this);
}
function Angle__equals_impl_zcf5mt($this, other) {
  if (!(other instanceof Angle()))
    return false;
  var tmp0_other_with_cast = other.turns_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var AngleClass;
function Angle() {
  if (AngleClass === VOID) {
    class $ {
      constructor(turns) {
        Companion_getInstance();
        this.turns_1 = turns;
      }
      toString() {
        return Angle__toString_impl_786qky(this.turns_1);
      }
      hashCode() {
        return Angle__hashCode_impl_szcndt(this.turns_1);
      }
      equals(other) {
        return Angle__equals_impl_zcf5mt(this.turns_1, other);
      }
    }
    initMetadataForClass($, 'Angle', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
    AngleClass = $;
  }
  return AngleClass;
}
//region block: exports
export {
  Angle as Angle36m0cdko0c63j,
  _Angle___init__impl__g23q1m as _Angle___init__impl__g23q1m3btd89vsaotdr,
  Angle__hashCode_impl_szcndt as Angle__hashCode_impl_szcndt3896t4hbc70ye,
  Angle__toString_impl_786qky as Angle__toString_impl_786qky378m8w1fbyftn,
  _Angle___get_turns__impl__atdtw5 as _Angle___get_turns__impl__atdtw5psbuz3qdt26e,
  Companion_getInstance as Companion_getInstance3o2pcl1yhcf6p,
};
//endregion

//# sourceMappingURL=Angle.mjs.map
